import { useQueryClient } from '@tanstack/react-query';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Flex, PageWrapper, StepNavigation } from '../../../components';
import { useHeroToast, useWarmup } from '../../../hooks';
import { useCreateDevice } from '../../../queries';
import { DeviceDocumentFirestoreRequest } from '../../../types';
import { CreateDeviceForm } from '../components';

export const CreateDevice: FC = () => {
  const [activeStep, setActiveStep] = useState<number>(1);
  const { showPromise, showError } = useHeroToast();
  const navigate = useNavigate();

  // Cold start funkcji v3 potrafi trwać kilka sekund — budzimy ją przy wejściu na formularz.
  useWarmup('v3-createDevice');

  const { mutate, isPending } = useCreateDevice();
  const queryClient = useQueryClient();
  const handleSubmit = (data : DeviceDocumentFirestoreRequest) : void => {
    showPromise(
      () => new Promise(
        (resolve, reject) => {
          mutate(
            { data },
            {
              onSuccess: resolve,
              onError: reject,
            },
          );
        },
      ),
    ).then(() => {
      navigate('/devices');
      queryClient.resetQueries({
        queryKey: ['pods'],
        exact: true,
      });
    }).catch((error) => {
      // Tłumaczenie leci w tle (trigger), więc błąd tu = błąd tworzenia urządzenia.
      const message = error?.response?.data?.message;
      showError(message || 'Device creation failed');
    });
  };

  return (
    <Flex direction="row" gap="small" fullHeight>
      <PageWrapper>
        <CreateDeviceForm
          onSubmit={(e) => handleSubmit(e)}
          activeStep={activeStep}
          onStepClick={setActiveStep}
        />
      </PageWrapper>
      <StepNavigation
        isLoading={isPending}
        showSubmit={activeStep === 5}
        form="form-create-device"
        skipAndSubmit
        isDisabled={isPending}
        previous={{
          showButton: activeStep > 1,
          label: 'Back',
          onClick: () => (setActiveStep(activeStep - 1)),
        }}
        next={{
          label: 'Next',
          onClick: () => (
            setActiveStep(activeStep + 1)
          ),
        }}
      />
    </Flex>
  );
};
